"use client";

import React from "react";

import type { QRProps } from "@/contexts/QREditorContext/types";
import { PhoneLayout } from "@/features/previews/layouts/PhoneLayout";

import { SmsHeader } from "./components/SmsHeader";
import { EmptyConversationWindow } from "./components/EmptyConversationWindow";
import { SmsFooter } from "./components/SmsFooter";
import { useSmsData } from "./hooks/useSmsData";

import "./SmsTemplate.scss";

export const SmsTemplate = (props: QRProps<"sms">) => {
  const { data, isInitPreview, displayName, profileImage, message } = useSmsData(props);

  if (!data) {
    return null;
  }

  return (
    <PhoneLayout
      page="sms"
      dataQA="preview-sms-container"
      isInitPreview={isInitPreview}
    >
      <div className="sms-preview">
        <SmsHeader
          displayName={displayName}
          profileImage={profileImage}
          isInitPreview={isInitPreview}
        />
        <EmptyConversationWindow />
        <SmsFooter
          message={message}
          isInitPreview={isInitPreview}
        />
      </div>
    </PhoneLayout>
  );
};
